var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',{attrs:{"validate":_vm.validate}},[_c('router-view',{attrs:{"regresavalor":_vm.regresavalors}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }